import request from '@/utils/request'
import { ouchnCustom } from "@/service"

// 我的资源查询我的书架
export function selectMyResourceListGoods(query){
  return request({
    url:ouchnCustom + '/web/myResource/selectMyResourceListGoods',
    method:'get',
    params: query
  })
}
// 删除我的书架
export function myResourceremove(query){
  return request({
    url:ouchnCustom + '/web/myResource/remove',
    method:'post',
    params: query
  })
}
// 我的资源 查询资源获取记录
export function selectMyResourceListGoodsNoBuy(query){
  return request({
    url:ouchnCustom + '/web/myResource/selectMyResourceListGoodsNoBuy',
    method:'get',
    params: query
  })
}
// 我的资源 我的专题
export function selectMyResourceListSubject(query){
  return request({
    url:ouchnCustom + '/web/myResource/selectMyResourceListSubject',
    method:'get',
    params: query
  })
}
// 我的资源 我的专题
export function selectMyResourceListBundle(query){
  return request({
    url:ouchnCustom + '/web/myResource/selectMyResourceListBundle',
    method:'get',
    params: query
  })
}
// 个人中心基础信息
export function selectUserByUserId(query){
  return request({
    url:ouchnCustom + '/web/ocFrontUser/selectUserByUserId',
    method:'get',
    params: query
  })
}
// 查询卡号,500:无效卡号，600：授权日期已过期，请确认，700：已被绑定，200成功
export function selectCardBuCardNo(query){
  return request({
    url:ouchnCustom + '/web/tbOrderAuthCard/selectCardBuCardNoV2',
    method:'get',
    params: query
  })
}
// 查询卡号使用的卡号
export function selectIsUsingCardPwd(query){
  return request({
    url:ouchnCustom + '/web/tbOrderAuthCard/selectIsUsingCardPwd',
    method:'get',
    params: query
  })
}
//
export function updateCode(query){
  return request({
    url:ouchnCustom + '/web/tbOrderAuthCard/updateCodeV2',
    method:'post',
    params: query
  })
}